import apiService from 'services/api'
import { AssignModal, AssignModalProps } from './BaseAssignModal'
import { useDataTableContext } from 'components/DataTable'
import { formatInteger } from 'utils/formatting'
import dayjs from 'dayjs'
import { CompanyDistributor } from '../../../models/companies'
import { DistributorsCell } from 'components/FbUI/StagePill'
import { ManageTagsDistributorsParams } from 'services/common_table_actions'

export default function DistributorAssignModal({
  tableObjAccessor = 'distributors',
  apiDistributorsAction,
  ...props
}: {
  tableObjAccessor?: string
  apiDistributorsAction: (params: ManageTagsDistributorsParams) => Promise<any>
} & Omit<
  AssignModalProps<CompanyDistributor, any>,
  | 'apiAction'
  | 'title'
  | 'subtitle'
  | 'pluralLabel'
  | 'singularLabel'
  | 'onConfirmAddNew'
  | 'items'
  | 'tableObjAccessor'
  | 'itemListKey'
>) {
  const api = apiService()
  const { data: distributors, refetch } = api.useGetDistributors()
  const {
    state: { totalSelectedRows },
  } = useDataTableContext()

  const apiAction = async (params: ManageTagsDistributorsParams) => {
    return await apiDistributorsAction(params)
  }

  return (
    <AssignModal
      {...props}
      title="Assign Distributors"
      subtitle={
        <span>
          Choose distributors to add or remove from{' '}
          <b>{formatInteger(totalSelectedRows)}</b> selected rows.
        </span>
      }
      refetchFn={refetch}
      pluralLabel="Distributors"
      singularLabel="Distributor"
      items={distributors ?? []}
      tableObjAccessor={tableObjAccessor!}
      apiAction={apiAction}
      itemListKey="distributor_ids"
      columns={[
        {
          accessorKey: 'name',
          header: 'Name',
        },
        {
          accessorKey: 'created',
          header: 'Date Created',
          cell: (info) => dayjs(info.getValue()).format('MMM DD YYYY'),
          meta: { rightAlign: true },
          size: 100,
        },
      ]}
      tableFooter={(selectedRows) => {
        return (
          <DistributorsCell
            nullPlaceholder={<></>}
            distributors={selectedRows}
            maxBadges={Infinity}
            className="items-center justify-center pt-3"
          />
        )
      }}
    />
  )
}
